export interface ApiRestrictedInvitationGroup {
    id: number;
    documentId?: string;
    name: string;
    prefix: string;
}

export interface ApiInvitation {
    id: number;
    documentId?: string;
    email: string;
    start?: string;
    expiration?: string;
    createdAt: string;
    userGroups?: ApiRestrictedInvitationGroup[]
    
}
export interface RestrictedInvitationGroup {
    id: number;
    documentId: string,
    name: string;
    prefix: string;
}

export const restrictedInvitationGroup = {

    apiUserGroupToUserGroup(apiUserGroup: ApiRestrictedInvitationGroup): RestrictedInvitationGroup {
        return ({
            id: apiUserGroup.id,
            documentId: apiUserGroup.documentId,
            name: apiUserGroup.name,
            prefix: apiUserGroup.prefix
        }) as RestrictedInvitationGroup;
    },

    apiUserGroupsToUserGroups(apiUserGroups: ApiRestrictedInvitationGroup[]): RestrictedInvitationGroup[] {

        if (!apiUserGroups) {
            return [];
        }

        return apiUserGroups.map((apiUserGroup: ApiRestrictedInvitationGroup) => restrictedInvitationGroup.apiUserGroupToUserGroup(apiUserGroup));
    }
};

export interface Invitation {
    id: number;
    documentId?: string;
    email: string;
    start?: string;
    expiration?: string;
    createdAt?: string;
    userGroups?: RestrictedInvitationGroup[];
}

export const invitation = {
    apiInvitationToInvitation(apiInvitation: ApiInvitation): Invitation {
        return {
            createdAt: apiInvitation.createdAt,
            email: apiInvitation.email,
            expiration: apiInvitation.expiration,
            id: apiInvitation.id,
            documentId: apiInvitation.documentId,
            start: apiInvitation.start,
            userGroups: restrictedInvitationGroup.apiUserGroupsToUserGroups(apiInvitation.userGroups ?? []),
        };
    },

    apiInvitationsToInvitations(apiInvitations: ApiInvitation[]): Invitation[] {
        if (!apiInvitations) {
            return [];
        }

        return apiInvitations.map((apiInvitation: ApiInvitation) => invitation.apiInvitationToInvitation(apiInvitation));
    }
};

export default { ...invitation, ...restrictedInvitationGroup };